webpackJsonp([2],{

/***/ 722:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_AuthForm__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_AuthFlowBase__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_withAuthAdapter__ = __webpack_require__(737);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// import createAuthSpinHandler from './lib/createAuthSpinHandler';

var SignInForm = function (_AuthForm) {
  _inherits(SignInForm, _AuthForm);

  function SignInForm() {
    _classCallCheck(this, SignInForm);

    return _possibleConstructorReturn(this, (SignInForm.__proto__ || Object.getPrototypeOf(SignInForm)).apply(this, arguments));
  }

  _createClass(SignInForm, [{
    key: "components",
    get: function get() {
      return [{
        id: "email",
        label: "Email",
        component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { ref: "autoFocus", type: "text" })
      }, {
        id: "password",
        label: "Password",
        component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", { type: "password" })
      }, {
        id: "submit",
        component: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "button",
          { type: "submit" },
          "Sign In"
        )
      }];
    }
  }]);

  return SignInForm;
}(__WEBPACK_IMPORTED_MODULE_1__lib_AuthForm__["a" /* default */]);

var SignIn = function (_AuthFlowBase) {
  _inherits(SignIn, _AuthFlowBase);

  function SignIn() {
    _classCallCheck(this, SignIn);

    return _possibleConstructorReturn(this, (SignIn.__proto__ || Object.getPrototypeOf(SignIn)).apply(this, arguments));
  }

  _createClass(SignIn, [{
    key: "handleSignIn",
    value: function handleSignIn(state) {
      var _this3 = this;

      this.clearValidationErrors();
      this.props.authAdapterFactory.authAdapter.signIn({
        email: state.email,
        password: state.password
      }).then(function (signInUserSession) {
        console.log("login success", signInUserSession.accessToken);
        // console.log('login success', accessToken, idToken, refreshToken);
        // console.log('access token + ' + result.getAccessToken().getJwtToken());
        // the cognitoUser.authenticateUser method already caches this to localStorage so we're done
        _this3.props.emitMetricEvent("auth", "sign-in");
        _this3.onSuccess();
        _this3.onSignIn();
      }).catch(this.handleValidationError.bind(this));
    }
  }, {
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "ul",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            null,
            "Don't have an account? Go ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Link */],
              { to: "/users/sign-up" },
              "Sign up"
            )
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            null,
            "Can't remember your password? Go to our",
            " ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Link */],
              { to: "/users/forgot-password" },
              "Forgot/Reset Password"
            ),
            " page"
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "li",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "strong",
              null,
              "note:"
            ),
            " Headless-Render-API.com",
            " ",
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "em",
              null,
              "was previously known"
            ),
            " as Prerender.cloud (rebranded 2022-05-01)"
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br", null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SignInForm, Object.assign({}, this.props, this.baseProps, {
          onSubmit: this.handleSignIn.bind(this)
        }))
      );
    }
  }]);

  return SignIn;
}(__WEBPACK_IMPORTED_MODULE_2__lib_AuthFlowBase__["a" /* default */]);

/* harmony default export */ __webpack_exports__["default"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib_withAuthAdapter__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(SignIn)));

/***/ }),

/***/ 733:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styleSheet = undefined;

var _extends2 = __webpack_require__(5);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(12);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = __webpack_require__(3);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(4);

var _classnames2 = _interopRequireDefault(_classnames);

var _jssThemeReactor = __webpack_require__(7);

var _withStyles = __webpack_require__(9);

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var transitionDuration = 4; // 400ms

//  weak

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('MuiLinearProgress', function (theme) {
  return {
    root: {
      position: 'relative',
      overflow: 'hidden',
      height: 5,
      backgroundColor: theme.palette.primary[100]
    },
    rootBuffer: {
      backgroundColor: 'transparent'
    },
    rootQuery: {
      transform: 'rotate(180deg)'
    },
    bar: {
      position: 'absolute',
      left: 0,
      bottom: 0,
      top: 0,
      transition: 'transform 0.2s linear',
      backgroundColor: theme.palette.primary[500]
    },
    dashed: {
      position: 'absolute',
      marginTop: 0,
      height: '100%',
      width: '100%',
      background: 'radial-gradient(' + theme.palette.primary[100] + ' 0%, ' + (theme.palette.primary[100] + ' 16%, transparent 42%)'),
      backgroundSize: '10px 10px',
      backgroundPosition: '0px -23px',
      animation: 'buffer 3s infinite linear'
    },
    indeterminateBar1: {
      willChange: 'left, right',
      animation: 'indeterminate-1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
    },
    indeterminateBar2: {
      willChange: 'left, right',
      animation: 'indeterminate-2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite',
      animationDelay: '1.15s'
    },
    determinateBar1: {
      willChange: 'width',
      transition: 'width .' + transitionDuration + 's linear'
    },
    determinateBar2: {
      display: 'none'
    },
    bufferBar1: {
      transition: 'width .' + transitionDuration + 's linear',
      backgroundColor: theme.palette.primary[100]
    },
    bufferBar2: {
      transition: 'width .' + transitionDuration + 's linear'
    },
    '@keyframes indeterminate-1': {
      '0%': {
        left: '-35%',
        right: '100%'
      },
      '60%': {
        left: '100%',
        right: '-90%'
      },
      '100%': {
        left: '100%',
        right: '-90%'
      }
    },
    '@keyframes indeterminate-2': {
      '0%': {
        left: '-200%',
        right: '100%'
      },
      '60%': {
        left: '107%',
        right: '-8%'
      },
      '100%': {
        left: '107%',
        right: '-8%'
      }
    },
    '@keyframes buffer': {
      '0%': {
        opacity: 1,
        backgroundPosition: '0px -23px'
      },
      '50%': {
        opacity: 0,
        backgroundPosition: '0px -23px'
      },
      '100%': {
        opacity: 1,
        backgroundPosition: '-200px -23px'
      }
    },
    '@keyframes query': {
      '0%': {
        opacity: 1,
        transform: 'translateX(35%) scale(.3, 1)'
      },
      '100%': {
        opacity: 0,
        transform: 'translateX(-50%) scale(0, 1)'
      }
    }
  };
});

function LinearProgress(props) {
  var _classNames, _classNames3, _classNames4;

  var classes = props.classes,
      className = props.className,
      mode = props.mode,
      value = props.value,
      valueBuffer = props.valueBuffer,
      other = (0, _objectWithoutProperties3.default)(props, ['classes', 'className', 'mode', 'value', 'valueBuffer']);

  var rootClasses = (0, _classnames2.default)(classes.root, (_classNames = {}, (0, _defineProperty3.default)(_classNames, classes.rootBuffer, mode === 'buffer'), (0, _defineProperty3.default)(_classNames, classes.rootQuery, mode === 'query'), _classNames), className);
  var dashedClasses = (0, _classnames2.default)((0, _defineProperty3.default)({}, classes.dashed, mode === 'buffer'));
  var bar1Classes = (0, _classnames2.default)(classes.bar, (_classNames3 = {}, (0, _defineProperty3.default)(_classNames3, classes.indeterminateBar1, mode === 'indeterminate' || mode === 'query'), (0, _defineProperty3.default)(_classNames3, classes.determinateBar1, mode === 'determinate'), (0, _defineProperty3.default)(_classNames3, classes.bufferBar1, mode === 'buffer'), _classNames3));
  var bar2Classes = (0, _classnames2.default)(classes.bar, (_classNames4 = {}, (0, _defineProperty3.default)(_classNames4, classes.indeterminateBar2, mode === 'indeterminate' || mode === 'query'), (0, _defineProperty3.default)(_classNames4, classes.determinateBar2, mode === 'determinate'), (0, _defineProperty3.default)(_classNames4, classes.bufferBar2, mode === 'buffer'), _classNames4));
  var styles = { bar1: {}, bar2: {} };
  var rootProps = {};

  if (mode === 'determinate') {
    styles.bar1.width = value + '%';
    rootProps['aria-valuenow'] = Math.round(value);
  } else if (mode === 'buffer') {
    styles.bar1.width = valueBuffer + '%';
    styles.bar2.width = value + '%';
  }

  return _react2.default.createElement(
    'div',
    (0, _extends3.default)({ className: rootClasses }, rootProps, other),
    _react2.default.createElement('div', { className: dashedClasses }),
    _react2.default.createElement('div', { className: bar1Classes, style: styles.bar1 }),
    _react2.default.createElement('div', { className: bar2Classes, style: styles.bar2 })
  );
}

LinearProgress.propTypes =  false ? {
  /**
   * Useful to extend the style applied to components.
   */
  classes: _propTypes2.default.object.isRequired,
  /**
   * @ignore
   */
  className: _propTypes2.default.string,
  /**
   * The mode of show your progress, indeterminate
   * for when there is no value for progress.
   */
  mode: _propTypes2.default.oneOf(['determinate', 'indeterminate', 'buffer', 'query']),
  /**
   * The value of progress, only works in determinate and buffer mode.
   * Value between 0 and 100.
   */
  value: _propTypes2.default.number,
  /**
   * The value of buffer, only works in buffer mode.
   * Value between 0 and 100.
   */
  valueBuffer: _propTypes2.default.number
} : {};

LinearProgress.defaultProps = {
  mode: 'indeterminate',
  value: 0
};

exports.default = (0, _withStyles2.default)(styleSheet)(LinearProgress);

/***/ }),

/***/ 736:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__errorHandler__ = __webpack_require__(264);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var cognitoConfig = {
  awsRegion: "us-west-2",
  clientId: "8uu17ati0lodfde5eo99eh1lb",
  userPoolId: "us-west-2_LLwNBLMEH",
  identityPoolId: "us-west-2:ef586dfa-e514-4038-9091-8784a0fb55ac"
};

var DummyAuthAdapter = function () {
  function DummyAuthAdapter() {
    _classCallCheck(this, DummyAuthAdapter);
  }

  _createClass(DummyAuthAdapter, [{
    key: "addSpinHandler",
    value: function addSpinHandler() {}
  }, {
    key: "removeSpinHandler",
    value: function removeSpinHandler() {}
  }, {
    key: "isSpinning",
    value: function isSpinning() {
      return false;
    }
  }, {
    key: "signUp",
    value: function signUp() {
      return Promise.reject(new Error("sign-in/sign-up disabled because window.localStorage is blocked or non-existent"));
    }
  }, {
    key: "signIn",
    value: function signIn() {
      return Promise.reject(new Error("sign-in/sign-up disabled because window.localStorage is blocked or non-existent"));
    }
  }]);

  return DummyAuthAdapter;
}();

var AuthAdapterFactory = function () {
  function AuthAdapterFactory() {
    _classCallCheck(this, AuthAdapterFactory);
  }

  _createClass(AuthAdapterFactory, [{
    key: "destroy",
    value: function destroy() {
      delete this._authAdapter;
    }
  }, {
    key: "onAuthError",
    value: function onAuthError() {
      console.log("caught onAuthError from AuthAdapter");
      // not sure what to do here (can't remember), just leaving it commented out.
      // this.destroy();
      // window.location.href = '/';
    }
  }, {
    key: "create",
    value: function create() {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (window.supportsLocalStorage()) {
          __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 744)).then(function (_ref) {
            var CognitoAuthAdapter = _ref.CognitoAuthAdapter;

            return resolve(new CognitoAuthAdapter(cognitoConfig.awsRegion, cognitoConfig.userPoolId, cognitoConfig.identityPoolId, cognitoConfig.clientId, __WEBPACK_IMPORTED_MODULE_0__errorHandler__["a" /* errorHandlerWithMessage */], _this.onAuthError.bind(_this)));
          }).catch(reject);
        } else {
          return resolve(new DummyAuthAdapter());
        }
      });
    }
  }, {
    key: "authAdapter",
    get: function get() {
      var _this2 = this;

      if (this._authAdapter) return Promise.resolve(this._authAdapter);

      return this.create().then(function (authAdapter) {
        _this2._authAdapter = authAdapter;
        return _this2._authAdapter;
      });
    }
  }]);

  return AuthAdapterFactory;
}();

window.authAdapter = new AuthAdapterFactory();

/* harmony default export */ __webpack_exports__["a"] = (window.authAdapter);

/***/ }),

/***/ 737:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuthAdapter__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Progress_LinearProgress__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_Progress_LinearProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_Progress_LinearProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_utils_customPropTypes__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_utils_customPropTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_utils_customPropTypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_styles__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_material_ui_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_material_ui_styles__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var styleSheet = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_material_ui_styles__["createStyleSheet"])("withAuthAdapter", function (theme) {
  window.theme = theme;
  return {
    spinner: {
      // position: "fixed",
      width: "100%"
    }
  };
});

/* harmony default export */ __webpack_exports__["a"] = (function (ComposedComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_Component) {
    _inherits(_class, _Component);

    function _class() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, _class);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = _class.__proto__ || Object.getPrototypeOf(_class)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(_class, [{
      key: "componentWillMount",
      value: function componentWillMount() {
        var _this2 = this;

        this.spinHandler = this._spinHandler.bind(this);

        __WEBPACK_IMPORTED_MODULE_1__AuthAdapter__["a" /* default */].authAdapter.then(function (authAdapter) {
          console.log("auth adapter created!", authAdapter);
          _this2.setState({ authAdapter: authAdapter });
          authAdapter.addSpinHandler(_this2.spinHandler);
        });
      }

      // since signing out destroys the authAdapter, and since we only "mount" a component once
      // we also need to addSpinHandler when new props are received (but the add method must then be idempotent)

    }, {
      key: "componentWillUpdate",
      value: function componentWillUpdate(props) {
        if (this.state.authAdapter) {
          this.state.authAdapter.addSpinHandler(this.spinHandler);
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (this.state.authAdapter) {
          this.state.authAdapter.removeSpinHandler(this.spinHandler);
        }
      }
    }, {
      key: "_spinHandler",
      value: function _spinHandler(isSpinning) {
        this.setState({ isSpinning: isSpinning });
      }
    }, {
      key: "renderComposed",
      value: function renderComposed() {
        if (this.state.authAdapter) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComposedComponent, Object.assign({}, this.props, {
            authAdapterFactory: { authAdapter: this.state.authAdapter }
          }));
        } else {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            "loading auth adapter"
          );
        }
      }
    }, {
      key: "render",
      value: function render() {
        var classes = this.context.styleManager.render(styleSheet);

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          null,
          this.state.isSpinning ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            { className: classes.spinner },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_material_ui_Progress_LinearProgress___default.a, { mode: "indeterminate" })
          ) : null,
          this.renderComposed()
        );
      }
    }]);

    return _class;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.contextTypes = {
    styleManager: __WEBPACK_IMPORTED_MODULE_3_material_ui_utils_customPropTypes___default.a.muiRequired
  }, _temp2;
});

/***/ }),

/***/ 738:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


// import AuthSpinHandler from "./AuthSpinHandler";

// must extend AuthSpinHandler to disable the inputs and buttons on form submission

var AuthFlowBase = function (_Component) {
  _inherits(AuthFlowBase, _Component);

  function AuthFlowBase(constructorProps) {
    _classCallCheck(this, AuthFlowBase);

    var _this = _possibleConstructorReturn(this, (AuthFlowBase.__proto__ || Object.getPrototypeOf(AuthFlowBase)).call(this));

    _this.state = {};
    return _this;
  }

  _createClass(AuthFlowBase, [{
    key: "onSuccess",
    value: function onSuccess() {
      this.props.history.push("/");
    }
  }, {
    key: "onSignIn",
    value: function onSignIn() {
      var _this2 = this;

      this.props.authAdapterFactory.authAdapter.onSpin(true);
      this.props.authAdapterFactory.authAdapter._syncData().then(function () {
        return _this2.props.authAdapterFactory.authAdapter.onSpin(false);
      });
    }
  }, {
    key: "onSignOut",
    value: function onSignOut() {
      window.wipeData();
    }
  }, {
    key: "handleValidationError",
    value: function handleValidationError(error) {
      this.setState({ validationErrors: error.message.split("\n") });
    }
  }, {
    key: "clearValidationErrors",
    value: function clearValidationErrors() {
      this.setState({ validationErrors: [] });
    }
  }, {
    key: "baseProps",
    get: function get() {
      return {
        isSpinning: this.state.isSpinning,
        validationErrors: this.state.validationErrors
      };
    }
  }]);

  return AuthFlowBase;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (AuthFlowBase);

/***/ }),

/***/ 745:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_utils_customPropTypes__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_material_ui_utils_customPropTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_material_ui_utils_customPropTypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_material_ui_styles___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_material_ui_styles__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




// import '../../style/Auth.css';

// div.auth-container { max-width: 40em; margin: 0 auto 0 0; }
// div.auth-container ul.auth-flows { list-style-type: none; display: flex; margin: 1.5em 0 0 0; padding: 0; }
// div.auth-container ul.auth-flows li { flex: 1; max-width: 4em; margin:0; }
// div.auth-container ul.auth-flows li a { cursor: pointer; color: blue; text-decoration: underline; }
// div.auth-container li { display: flex; margin: 0 0 1em 0; flex-wrap: wrap;}
// div.auth-container li>label,li>div { min-width: 5em; }
// div.auth-container li>label { flex: 2; }
// div.auth-container li>div { flex: 5; }

// div.auth-container li>label {font-size: 1.3em;text-align: right; padding: 0.2em 0.5em 0 0; font-weight: bold;}
// div.auth-container li>div>input { max-width: 15em; width: 100%; font-size: 1.3em; line-height: 1.3em; }
// div.auth-container li>div>button { font-size: 1.3em; }

// div.auth-container div.errors {  text-align: center; background: rgba(255, 0, 0, 0.15); padding: 0.3em; margin: 1em auto; font-weight: bold;}

// @media (min-width: 500px) {
//   div.auth-container div.errors { max-width: 50%; }
// }



var styleSheet = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_material_ui_styles__["createStyleSheet"])("AuthForm", function (theme) {
  window.theme = theme;
  return {
    root: {
      maxWidth: "40em",
      margin: "0 auto 0 0",

      "& ul": {
        "& li": {
          display: "flex",
          flex: 1,
          margin: "0 0 1em 0",
          flexWrap: "wrap",
          "& label": {
            minWidth: "5em",
            flex: 2,
            fontSize: "1.3em",
            textAlign: "right",
            padding: "0.2em 0.5em 0 0",
            fontWeight: "bold"
          },
          "& div": {
            minWidth: "5em",
            flex: 5,
            "& button": {
              fontSize: "1.3em"
            },
            "& input": {
              maxWidth: "15em",
              width: "100%",
              fontSize: "1.3em",
              lineHeight: "1.3em"
            }
          }
        }
      }
    },
    errors: {
      textAlign: "center",
      background: "rgba(255, 0, 0, 0.15)",
      padding: "0.3em",
      margin: "1em auto",
      fontWeight: "bold"
    }
  };
});

// FORM SUPERCLASS (wraps form elements in styled html structure)

var AuthForm = function (_Component) {
  _inherits(AuthForm, _Component);

  function AuthForm() {
    _classCallCheck(this, AuthForm);

    var _this = _possibleConstructorReturn(this, (AuthForm.__proto__ || Object.getPrototypeOf(AuthForm)).call(this));

    _this.state = {};
    return _this;
  }

  _createClass(AuthForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.refs.autoFocus) __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this.refs.autoFocus).focus();
    }
  }, {
    key: "submitWrapper",
    value: function submitWrapper(fn) {
      var _this2 = this;

      return function (e) {
        e.preventDefault();
        return fn(_this2.state);
      };
    }
  }, {
    key: "errorsExist",
    value: function errorsExist() {
      return !!(this.props.validationErrors && this.props.validationErrors.length);
    }
  }, {
    key: "renderErrors",
    value: function renderErrors() {
      return {
        __html: this.props.validationErrors && this.props.validationErrors.join("<br />")
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var classes = this.context.styleManager.render(styleSheet);

      var formElements = this.components.map(function (c, n) {
        // button calls onSubmit prop
        if (c.component.type === "button") {
          c.component = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(c.component, {
            onClick: _this3.submitWrapper(_this3.props.onSubmit),
            disabled: _this3.props.isSpinning
          });
        }

        // add "controlled form" event handlers
        if (c.component.type === "input") {
          c.component = __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(c.component, {
            disabled: _this3.props.isSpinning,
            onChange: function onChange(e) {
              var tmpObj = {};
              tmpObj[c.id] = e.target.value;
              _this3.setState(tmpObj);
            },
            value: _this3.state[c.id] || ""
          });
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "li",
          { key: n },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "label",
            { htmlFor: c.id },
            c.label
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "div",
            null,
            c.component
          )
        );
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "div",
        null,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "div",
          { className: classes.root },
          this.errorsExist() ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
            className: classes.errors,
            dangerouslySetInnerHTML: this.renderErrors()
          }) : null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "form",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              "ul",
              null,
              formElements
            )
          ),
          this.props.children
        )
      );
    }
  }]);

  return AuthForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AuthForm.contextTypes = {
  styleManager: __WEBPACK_IMPORTED_MODULE_2_material_ui_utils_customPropTypes___default.a.muiRequired
};
/* harmony default export */ __webpack_exports__["a"] = (AuthForm);

/***/ })

});


// WEBPACK FOOTER //
// static/js/2.b1c3ec2f.chunk.js